import React from "react";

import {
  FaReact,
  FaCode,
  FaNodeJs,
  FaHtml5,
  FaLaptopCode
} from "react-icons/fa";
import { GrGatsbyjs } from "react-icons/gr";
import { SiNextDotJs } from "react-icons/si";

export default [
  {
    icon: <FaHtml5 />,
    title: "PSD to HTML",
    text:
      "I can turn your designs into web standards compliant HTML5/CSS3 package. I am also doing JavaScript development. I create code according to W3C standards, and my markup is displayed correctly in all popular modern browsers.",
  },
  {
    icon: <FaCode />,
    title: "Front-end Development",
    text:
      "Whether you’re looking for an external development partner, or expert developers to integrate with your in-house team, i will provide the right talent for your project. I as  front-end developer can not only supply technical expertise, but make sure your project is done the right way.",
  },
  {
    icon: <FaNodeJs />,
    title: "Back-end Development",
    text:
      "Node.js is an open source, cross-platform built on Chrome’s JavaScript runtime for fast and scalable server-side and networking applications. Being an interface to the V8 JavaScript runtime, it enables event-driven programming to the web servers through super-fast JavaScript interpreter that runs in the Chrome browser.",
  },
  {
    icon: <FaReact />,
    title: "ReactJS Development",
    text:
      "ReactJS is renowned for its extensibility, adjustability and convenience. Many of the developers acknowledge it one of the best JavaScript open source libraries. It makes possible the creation of such complex software as web browser and mobile application user interfaces that accommodate to the strictest standards.",
  },

  {
    icon: <GrGatsbyjs />,
    title: "Gatsby Development",
    text:
      "Gatsby websites are much faster than the average website, and that directly equates to real-world business performance gains. Amazon has claimed that if their site took just one second longer to load it would cost them $1.6 billion per year, and Walmart found that for every second they could make their website faster their conversion rates increased 2%. Google also uses website speed as a ranking factor, by building your new website in Gatsby you are more likely to out-perform your competitors.",
  },

  {
    icon: <SiNextDotJs />,
    title: "NextJS App Development",
    text:
      "Are you Looking for a NextJS Developer? You can hire me as a Freelance NextJS Developer. NextJS can be a great choice for your web application. Server-side rendering and static site generation are not only good for SEO but also to improve perceived loading times. And if required, you can also decide to render parts or your entire application only on the client. NextJS is also ready for PWAs out of the box.",
  },
];
